module.exports = __webpack_public_path__ + "static/img/btn.5e9bb71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/73/new/btn.png
// module id = J6Cx
// module chunks = 0